import React, { FC } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

type BackdropLoaderProps = {
    isOpen: boolean;
    /** Optional explanation shown under the spinner, e.g. why the user has to wait. */
    message?: string;
};

const BackdropLoader: FC<BackdropLoaderProps> = ({ isOpen, message }: BackdropLoaderProps) => {
    return (
        <Backdrop sx={(theme) => ({ zIndex: theme.zIndex.drawer + 1, color: '#fff' })} open={isOpen}>
            <Box display="flex" flexDirection="column" alignItems="center" gap={2} maxWidth={480} px={2}>
                <CircularProgress variant="indeterminate" color="secondary" />
                {message && (
                    <Typography variant="body1" align="center" role="status">
                        {message}
                    </Typography>
                )}
            </Box>
        </Backdrop>
    );
};

export default BackdropLoader;
